module.exports = __webpack_public_path__ + "img/venture-logo.8a2c9797.png";